const NO_WIDTH = 0

export enum KeyType {
  Balance = 'balance',
  RemainingBalanceCapacity = 'remainingBalanceCapacity',
}

// We need the HEX color code for the Nivo Bar fillings
const keyColorMap = {
  [KeyType.Balance]: '#FF9153', // tangerine1000
  [KeyType.RemainingBalanceCapacity]: '#FFDFCD', // tangerine200
}

export const keys = Object.keys(keyColorMap)
export const colors = Object.values(keyColorMap)

type Data = {
  [key in KeyType]: number
}

export const generateData = (balancePoolMinutes: number, balancePoolCapacity: number): Data => {
  if (balancePoolCapacity === Infinity) {
    return {
      balance: NO_WIDTH,
      remainingBalanceCapacity: NO_WIDTH,
    }
  }

  if (balancePoolMinutes > 0) {
    return {
      balance: balancePoolMinutes,
      remainingBalanceCapacity: balancePoolCapacity - balancePoolMinutes,
    }
  }

  return {
    balance: NO_WIDTH,
    remainingBalanceCapacity: NO_WIDTH,
  }
}
